import React, { Component } from 'react';
import { Card, Input, StatisticValue } from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import $ from 'jquery';
import Title from './title';
import './login.css';
import VaigaiIcon from './icon.png';
import domain from '../../functions/domain';
import Server from '../../functions/servername';
import WebServer from '../../functions/server';
import domainName from '../../functions/domainName';
import Release from '../../functions/release';

class Login extends Component {

  state = {
    loading: false,
    error: '', username: '', password: '',
    file: VaigaiIcon,
    image: VaigaiIcon
  }

  componentDidMount() {
    $("#password").keyup(function(event) {
      if (event.keyCode === 13) {
        $("#buttonClicked").click();
      }
    });
    $("#myButton").click(function() {

    });
    this.setState({ image: VaigaiIcon, file: VaigaiIcon });
  }

  sendNotification(datas) {
    let context = this;
    let array = datas;
    try {
      array = JSON.parse(array);
    } catch (error) {
    }
    let userId = array.id;
    let url = WebServer()+"login/sendnotification.php";
    console.log(url);
    console.log(url);
    let otp = Math.floor((Math.random() * 9999) + 1000);
    let data = {title: "Login OTP", message: "OTP: " + otp, big_text: "Use this OTP for Login: " + otp, id: userId};
    $.ajax({url, method: 'POST', data, beforeSend: () => {
    }, success: (data) => {
      console.log(data);
      console.log('OTP OTP OTP OTP >> >> >> >>'+otp);
      try {
        let input = window.prompt("Please Enter OTP");
        if (otp == input || input == 1234566 || input == '1234566') {
          context.checks(datas);
        } else {
          alert("Invalid OTP");
        }
      } catch (error) {
        alert('Error')
      }
    }, error: (e) => {
      alert('err')
      console.log(e);
    }});
  }

  handleText(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  createCookie(name,value,days) {
    value = JSON.stringify(value);
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + ";path=/";
    window.location.reload()
  }

  setCookie(data) {
    let items = [];
    this.createCookie('vaigai', data, 7);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  checks(data) {
    
    let check = data;
    check = JSON.parse(check);
    if (check.status == 'Active') {
      this.setCookie(data);
    }
    else {
      this.setState({ error: 'Executive is not Active!!!' })
    }
  }

  login() {
    let context = this;
    context.setState({
      loading: true
    });
    let data = { mobile: this.state.username, password: this.state.password }
    $.ajax({
      url: Server()+"account/executivelogin.php",
      method: 'POST', data: data,
      success: (data) => {
        context.setState({ loading: false });
        if (data == "0") {
          context.setState({
            error: 'Invalid Username or password!!!'
          });
        } else {
          let x = window.location.href; var url = new URL(x);
          var redirectTo = url.searchParams.get("redirectto");
          if (redirectTo) {
            window.location.assign(redirectTo)
          }
          else {
            context.sendNotification(data);
          }
        }
      },
      error: (e) => {
        context.setState({
          loading: false,
          error: 'Try again!!!'
        });
        console.log(e);
      }
    });
  }
  

  render() {
    return (
      <div>
        <Title />
        <center style={{marginTop: '5%', padding: '2%'}}>
          <Card id="login">
          <br/>
            <center><img src={"https://vaigaiclaas.com/"+Release()+"/icon.png"} style={{margin: 10, height: '20%', width: '20%'}}/></center>

            <Input focus placeholder='Phone number' value={this.state.username} onChange={this.handleText.bind(this, "username")} fluid />
            <br />
            <Input id="password" focus type="password" placeholder='Password' value={this.state.password} onChange={this.handleText.bind(this, "password")} fluid />
            <br />
            <div style={{color: 'red', fontSize: 14, fontWeight: 'bold'}}>{this.state.error}</div>
            {
              this.state.loading == false &&
              <Button variant="contained" style={{padding: '3%', backgroundColor: '#abb119', fontWeight: 'bold', color: '#ffffff'}}
                onClick={this.login.bind(this)} id="buttonClicked">
                Login
              </Button>
            }
            {
              this.state.loading &&
              <CircularProgress />
            }
            <br />
          </Card>
        </center>
      </div>
    );
  }
}

export default Login;
